import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const basePath: string = (window as any).__env.API_BASE_PATH;
    if (request.url.toLowerCase().includes(basePath.toLowerCase())) {
      const token = this.currentToken();

      if (token) {
        // console.log(token)
        return next.handle(
          request.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          })
        );
      }
    }
    return next.handle(request);
  }

  currentToken(): string {
    const token = sessionStorage.getItem('currentToken') || localStorage.getItem('currentToken');
    if (token && token.length > 0) {
      return token;
    } else {
      localStorage.removeItem('currentToken');
      sessionStorage.removeItem('currentToken');
      // tslint:disable-next-line: deprecation
      // location.reload(true);
      return null;
    }
  }
}
